import { actionTypes, mutationTypes, getterTypes } from './unit.moduletypes';

import { UnitCreation, UnitCreationResponse, UnitUpdate, MachineGroup, CardUpdate, CardNameUpdate } from '../models/unit.models';

const actions = {
  [actionTypes.saveUnit]({ getters, commit, dispatch }, data) {
    let unitCreation = new UnitCreation(data);
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .createUnit(unitCreation)
        .then(result => {
          let { urlGuid, imageApiUrl } = new UnitCreationResponse(result.data);
          let { logo, contacts, groups, unitImage } = data;

          let promises = [];
          promises.push(dispatch(actionTypes.updateUnit, { data, urlGuid }));
          if (logo !== '') {
            promises.push(
              dispatch(actionTypes.uploadImage, {
                imageData: logo,
                unitGuid: urlGuid,
                imageApiUrl,
                imagePurpose: 2
              })
            );
          }
          if (unitImage !== '') {
            promises.push(
              dispatch(actionTypes.uploadImage, {
                imageData: unitImage,
                unitGuid: urlGuid,
                imageApiUrl,
                imagePurpose: 1
              })
            );
          }
          if (contacts.length > 0) {
            promises.push(
              dispatch(actionTypes.setContacts, {
                contacts: { contacts },
                urlGuid
              })
            );
          }
          let orderedGroups = new MachineGroup({
            unitGuid: urlGuid,
            machineGroups: groups
          });
          if (orderedGroups.machineGroups.length > 0) {
            promises.push(
              dispatch(actionTypes.saveGroups, {
                groups: orderedGroups
              })
            );
          }
          return Promise.all(promises).then(() => {
            resolve();
          });
        })
        .catch(error => {
          console.error('Error occured create Unit: ' + error);
          reject(error);
        });
    });
  },

  [actionTypes.getAllUnits]({ getters, commit }) {
    return new Promise(resolve => {
      getters[getterTypes.UnitApi].getUnits().then(result => {
        let { data } = result;
        commit(mutationTypes.addUnits, data);
        resolve(result);
      });
    });
  },

  [actionTypes.getOneUnit]({ getters, commit }, urlGuid) {
    return new Promise(resolve => {
      getters[getterTypes.UnitApi].getOneUnit(urlGuid).then(result => {
        let { data } = result;
        commit(mutationTypes.addCurrentUnit, data);
        resolve(result);
      });
    });
  },

  [actionTypes.deleteUnit]({ getters }, { urlGuid }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .deleteUnit(urlGuid)
        .then(result => {
          resolve(result);
        })
        .catch(() => {
          reject();
        });
    });
  },

  [actionTypes.saveGroups]({ getters }, { groups }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .saveGroups(groups)
        .then(result => {
          let { data } = result;
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in save groups: ' + error);
          reject();
        });
    });
  },

  [actionTypes.uploadImage]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .uploadImage(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in upload image: ' + error);
          reject();
        });
    });
  },

  [actionTypes.setContacts]({ getters }, { urlGuid, contacts }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .setContacts(urlGuid, contacts)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in setContacts: ' + error);
          reject();
        });
    });
  },

  [actionTypes.updateUnit]({ getters }, { data, urlGuid }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi].getTimeZone(data.geoLocation).then(result => {
        data.timeZone = result.data.timeZoneId;
        let unitUpdate = new UnitUpdate(data);
        getters[getterTypes.UnitApi]
          .updateUnit(urlGuid, unitUpdate)
          .then(result => {
            resolve(result);
          })
          .catch(error => {
            console.error('Error occured in update Unit: ' + error);
            reject();
          });
      });
    });
  },

  [actionTypes.editUnit]({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      let promises = [];
      let { urlGuid, logo, contacts, unitImage } = data;
      promises.push(
        dispatch(actionTypes.updateUnit, {
          data,
          urlGuid
        })
      );
      if (logo !== '') {
        promises.push(
          dispatch(actionTypes.uploadImage, {
            imageData: logo,
            unitGuid: urlGuid,
            imagePurpose: 2
          })
        );
      }
      if (unitImage !== '') {
        promises.push(
          dispatch(actionTypes.uploadImage, {
            imageData: unitImage,
            unitGuid: urlGuid,
            imagePurpose: 1
          })
        );
      }
      if (contacts.length > 0) {
        promises.push(
          dispatch(actionTypes.setContacts, {
            contacts: { contacts },
            urlGuid
          })
        );
      }
      return Promise.all(promises).then(() => {
        resolve();
      });
    });
  },

  [actionTypes.shareUnit]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .shareUnit(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in shareUnit: ' + error);
          reject();
        });
    });
  },

  [actionTypes.changePermission]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .changePermission(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in changePermission: ' + error);
          reject();
        });
    });
  },

  [actionTypes.leaveUnit]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .leaveUnit(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in leaveUnit: ' + error);
          reject();
        });
    });
  },

  [actionTypes.removeUser]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .removeUser(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in removeUser: ' + error);
          reject();
        });
    });
  },

  [actionTypes.manageRights]({ dispatch }, data) {
    return new Promise(resolve => {
      let { manageRightsObject, unitGuid } = data;
      let promises = [];
      if (manageRightsObject.changePermission.length > 0) {
        manageRightsObject.changePermission.forEach(permission => {
          promises.push(
            dispatch(actionTypes.changePermission, {
              unitGuid,
              userTargetEmail: permission.email,
              userTargetRole: permission.userRole
            })
          );
        });
      }
      if (manageRightsObject.removeUser.length > 0) {
        manageRightsObject.removeUser.forEach(permission => {
          promises.push(
            dispatch(actionTypes.removeUser, {
              unitGuid,
              userToRemove: permission.id
            })
          );
        });
      }
      return Promise.all(promises).then(() => {
        if (manageRightsObject.leaveUnit.length > 0) {
          let promisesForLeaveUnit = [];
          manageRightsObject.leaveUnit.forEach(() => {
            promisesForLeaveUnit.push(
              dispatch(actionTypes.leaveUnit, {
                unitGuid
              })
            );
          });
          return Promise.all(promisesForLeaveUnit).then(() => {
            resolve();
          });
        } else {
          resolve();
        }
      });
    });
  },

  [actionTypes.moveMachine]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .moveMachine(data)
        .then(result => {
          let { groupIndex, cardIndex, index } = data;
          commit(mutationTypes.moveMachineCard, { groupIndex, cardIndex, index });
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in moveMachine: ' + error);
          reject();
        });
    });
  },

  [actionTypes.addCard]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .addCard(data)
        .then(result => {
          commit(mutationTypes.addCardToCurrentUnit, { cardData: result.data, data });
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in addCard: ' + error);
          reject();
        });
    });
  },

  [actionTypes.deleteCard]({ getters, commit }, { machineGuid, groupIndex, cardIndex }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .deleteCard(machineGuid)
        .then(result => {
          commit(mutationTypes.deleteCard, { groupIndex, cardIndex });
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in deleteCard: ' + error);
          reject();
        });
    });
  },

  [actionTypes.updateCard]({ getters, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let { urlGuid } = data;
      let cardUpdate = new CardUpdate(data);
      getters[getterTypes.UnitApi]
        .updateCard(urlGuid, cardUpdate)
        .then(result => {
          resolve(result);
          if (data.machineName !== '') {
            return dispatch(actionTypes.updateCardName, { data }).then(result => {
              resolve(result);
            });
          }
        })
        .catch(error => {
          console.error('Error occured in updateCard: ' + error);
          reject();
        });
    });
  },

  [actionTypes.updateCardName]({ getters }, { data }) {
    return new Promise((resolve, reject) => {
      let { urlGuid } = data;
      let cardNameUpdate = new CardNameUpdate(data);
      getters[getterTypes.UnitApi]
        .updateCardName(urlGuid, cardNameUpdate)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in updateCardName: ' + error);
          reject();
        });
    });
  },

  [actionTypes.addGroup]({ getters, commit }, { groups }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .saveGroups(groups)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.addGroupToCurrentUnit, data[0]);
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in save groups: ' + error);
          reject();
        });
    });
  },

  [actionTypes.deleteGroup]({ getters, commit }, { groupGuid, index }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .deleteGroup(groupGuid)
        .then(result => {
          commit(mutationTypes.deleteGroup, index);
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in deleteGroup: ' + error);
          reject();
        });
    });
  },

  [actionTypes.renameGroup]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .renameGroup(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in renameGroup: ' + error);
          reject();
        });
    });
  },

  [actionTypes.renameCard]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .renameCard(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in renameCard: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getCurrentMachine]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .getCurrentMachine(data)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setCurrentMachine, data);
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in get current machine: ' + error);
          reject();
        });
    });
  },

  [actionTypes.copyProductionCounter]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .copyProductionCounter(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in copyProductionCounter: ' + error);
          reject(error);
        });
    });
  },

  [actionTypes.getCurrentWires]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .getWiresForMachine(data)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setCurrentWires, data);
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in regetCurrentWiresameCard: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getWiresOptionForPosition]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .getWiresOptionForPosition(data)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setWiresOptionForPosition, data);
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in getWiresOptionForPosition: ' + error);
          reject();
        });
    });
  },

  [actionTypes.setWireOnPosition]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .setWireOnPosition(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in setWireOnPosition: ' + error);
          reject();
        });
    });
  },

  [actionTypes.removeWireOnPosition]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .removeWireOnPosition(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in removeWireOnPosition: ' + error);
          reject();
        });
    });
  },

  [actionTypes.updateTons]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .updateTons(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in updateTons: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getMachinesConfigurations]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .getMachineConfigurationData(data)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setMachinesConfigurations, data);
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in getMachinesConfigurations: ' + error);
          reject();
        });
    });
  },

  /**
   * does not change store
   */
  [actionTypes.getMatchingMachinesConfigurations]({ getters, commit }, machineGuid) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .getMachineConfigurationDataForConfiguredMachine(machineGuid)
        .then(result => {
          let { data } = result;
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in getMatchingMachinesConfigurations: ' + error);
          reject();
        });
    });
  },

  [actionTypes.identifyMachine]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .identifyMachine(data)
        .then(result => {
          let { data } = result;
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in identifyMachine: ' + error);
          reject();
        });
    });
  },

  [actionTypes.maintenance]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .maintenance(data)
        .then(result => {
          let { data } = result;
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in maintenance: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getCopyConfiguration]({ getters, commit }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .getCopyConfiguration(data)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setCopyConfiguration, data);
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in getCopyConfiguration: ' + error);
          reject();
        });
    });
  },

  [actionTypes.copyConfiguration]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .copyConfiguration(data)
        .then(result => {
          let { data } = result;
          resolve(data);
        })
        .catch(error => {
          console.error('Error occured in copyConfiguration: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getEasySetupData]({ getters, commit }, data) {
    const isLocalDev = process.env.NODE_ENV === 'development';

    if(isLocalDev){
        return new Promise((resolve, reject) => {
            getters[getterTypes.UnitApi]
            .easySetupTestData([
                {
                    "machines": [
                        {
                            "modelNumber": {},
                            "wires": [
                                {
                                    "position": "CYLINDER",
                                    "itemId": "900900045477"
                                }
                            ]
                        }
                    ]
                }
            ])
            .then(result => {
            let { data } = result;
            commit(mutationTypes.setEasySetup, data.easySetupData);
            resolve(data);
            })
            .catch(error => {
            console.error('Error occured in get easy setup data: ' + error);
            reject();
            });
        });
    }
    else{
        return new Promise((resolve, reject) => {
            getters[getterTypes.UnitApi]
            .easySetupData(data)
            .then(result => {
              let { data } = result;
              commit(mutationTypes.setEasySetup, data);
              resolve(data);
            })
            .then(result => {
            let { data } = result;
            commit(mutationTypes.setEasySetup, data.easySetupData);
            resolve(data);
            })
            .catch(error => {
            console.error('Error occured in get easy setup data: ' + error);
            reject();
            });
        });
    }
  },

  /**
   * does not change store
   */
  [actionTypes.changeMachineStateAction]({ getters, commit }, UpdateMachineStateInputModel) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.UnitApi]
        .changeMachineState(UpdateMachineStateInputModel)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in changeMachineStateAction: ' + error);
          reject();
        });
    });
  }
};

export default actions;
